import {
  Tag as RACTag,
  TagGroup as RACTagGroup,
  type TagGroupProps as RACTagGroupProps,
  TagList as RACTagList,
  type TagListProps as RACTagListProps,
  type TagProps as RACTagProps,
} from "react-aria-components";

export interface TagGroupProps extends RACTagGroupProps {}

export function TagGroup(props: TagGroupProps) {
  return <RACTagGroup {...props} />;
}

export interface TagListProps<T extends object> extends RACTagListProps<T> {}

export function TagList<T extends object>(props: TagListProps<T>) {
  return <RACTagList {...props} />;
}

export interface TagProps extends RACTagProps {}

export function Tag(props: TagProps) {
  return <RACTag {...props} />;
}
